import MockAdapter from 'axios-mock-adapter'
// import promisedPayment from 'api/promised-payment/v1/mock'
// import organization from 'api/organization/v1/mock'
// import referrals from 'api/referrals/v1/mock'
// import user from 'api/user/v1/mock'
// import texts from 'api/texts/v1/mock'
// import advertisers from 'api/advertisers/v1/mock'
// import agency from 'api/agency/v1/mock'
// import pulse from 'api/pulse/v2/mock'
// import services_accesses_vk_ads from 'api/services/accesses/vk-ads/v1/mock'
// import services_accesses_vk from 'api/services/accesses/vk/v1/mock'
// import accountManager from 'api/statistics/account-manager/v1/mock'
// import statistics from 'api/statistics/v2/mock'
// import statisticsAccount from 'api/statistics/account/v2/mock'
// import statisticsCampaign from 'api/statistics/campaign/v2/mock'
// import advertising_types from 'api/advertising-types/v2/mock'
// import wallets from 'api/wallets/v1/mock'
// import audits from 'api/recommendations/v1/mock'
// import recommendations from 'api/recommendations/v2/mock'
// import oauth from 'api/oauth/v1/mock'
// import security from 'api/security/v1/mock'
// import payouts from 'api/payouts/v1/mock'
//import tickets from 'api/tickets/v1/mock'
// import notifications from 'api/notifications/v1/mock'
// import vkads from 'api/networks/vk-ads/v1/mock'
// import billing from 'api/billing/v1/mock'
// import partner_program from 'api/partner-program/v1/mock'
// import countries from 'api/countries/v1/mock'
// import stories from 'api/stories/v1/mock'
// import yandex from 'api/yandex/v1/mock'
// import mediaPlanner from 'api/media-planner/v1/mock'
// import accountsMarketplace from 'api/accounts-marketplace/v1/mock'
//import payoutprofiles from 'api/payout/payout/v1/mock'
//import benchmarks from 'api/benchmarks/v1/mock'

const addMocks = (axios) => {
  const mock = new MockAdapter(axios, { delayResponse: 3000 })

  mock.attachMocks = function (mockFunctions) {
    let ctx = this

    mockFunctions.forEach((mockFunction) => {
      mockFunction(ctx)
    })

    return ctx
  }

  mock
    .attachMocks([
      //payoutprofiles,
      //notifications,
      //tickets,
      //benchmarks,
      //banners,
      //security,
      //promisedPayment,
      //services,
      //services2,
      //services_accesses_vk_ads,
      //services_accesses_vk,
      //advertisers,
      //agency,
      //statistics,
      //accountManager,
      //statisticsAccount,
      //statisticsCampaign,
      //pulse,
      //texts,
      //paymentProfiles,
      //user,
      // billing,
      //wallets,
      //user,
      //wallets,
      //organization,
      //referrals,
      //referral,
      //audits,
      //recommendations,
      //oauth,
      //payouts,
      //advertising_types,
      //vkads,
      //partner_program,
      //stories,
      //countries,
      //yandex,
      //mediaPlanner,
      //accountsMarketplace,
    ])
    .onAny()
    .passThrough()
}
export default addMocks
